import { EntityManagerHelper } from '@core/helpers/entity-manager.helper';
import { DataService, Entity, EntityManager, EntityQuery, MetadataStore, NamingConvention } from 'breeze-client';
import { enableSaveQueuing } from 'breeze-client/mixin-save-queuing';
import { BaseService } from './base.service';

export class BreezeBaseService extends BaseService {
  protected em: EntityManager;
  protected entityManagerHelper: EntityManagerHelper;
  private localCacheQueries: unknown = {};

  public constructor(url: string, metadataString: string) {
    super();
    this.em = this.createManager(url, metadataString);
    this.entityManagerHelper = new EntityManagerHelper(this.em);
  }

  protected executeQuery<T = Entity>(query: EntityQuery) {
    return this.entityManagerHelper.executeQuery<T>(query);
  }

  protected async executeQueryResults<T = Entity>(query: EntityQuery) {
    const response = await this.entityManagerHelper.executeQuery<T>(query);
    return response.results;
  }

  protected async executeQueryResult<T = Entity>(query: EntityQuery) {
    const results = await this.executeQueryResults<T>(query);
    return results[0];
  }

  private createManager(url: string, metadataString: string): EntityManager {
    NamingConvention.camelCase.setAsDefault();

    const dataService = new DataService({
      serviceName: this.baseUrl + '/breeze/' + url + '/',
      hasServerMetadata: true
    });
    const metadataStore = new MetadataStore({});
    const manager = new EntityManager({
      dataService: dataService,
      metadataStore: metadataStore
    });

    enableSaveQueuing(manager, true);

    return manager;
  }

  public entityManagerHasChanges() {
    return this.em.hasChanges();
  }

  public isQueryCached(query: EntityQuery): boolean {
    if (this.localCacheQueries[JSON.stringify(query)]) return true;

    return false;
  }

  public addLocalQuery(query: EntityQuery): void {
    this.localCacheQueries[JSON.stringify(query)] = 1;
  }

  public resetCache() {
    this.localCacheQueries = {};
  }
}
